import React from 'react';
import { Eye } from 'lucide-react';
import { dirMeta } from './RadarPrep';

const fmt = (v) => {
    const n = Number(v);
    return `$${n.toLocaleString('en-US', { maximumFractionDigits: n >= 1000 ? 2 : n >= 1 ? 4 : 8 })}`;
};

const NearChip = ({ n, symbol }) => (
    <div data-testid={`radar-watch-near-${symbol}-${n.key}`} className="space-y-0.5" title={n.text_tr}>
        <div className="flex items-center justify-between gap-2 text-[10px]">
            <span className="text-slate-200 truncate">{n.text_tr}</span>
            <span className="font-mono text-amber-300 shrink-0">%{n.progress}</span>
        </div>
        <div className="h-1 rounded-sm bg-slate-700 overflow-hidden">
            <div className="h-full bg-amber-400/80" style={{ width: `${n.progress}%` }} />
        </div>
    </div>
);

const SHORT_LABEL = { pattern: 'Desen', squeeze: 'Sıkışma', oi: 'OI', volume: 'Hacim', breakout: 'Kırılım', mtf: 'MTF', funding: 'Fonlama' };

export default function RadarWatchCard({ row, onSelect }) {
    const rd = row.radar;
    const m = dirMeta(rd.direction);
    const passedKeys = rd.checks.filter((c) => c.passed).map((c) => SHORT_LABEL[c.key] || c.label);
    return (
        <button
            type="button"
            onClick={() => onSelect?.(row.symbol)}
            data-testid={`radar-watch-card-${row.symbol}`}
            className="text-left w-full rounded-lg border border-sky-500/25 bg-slate-900/60 hover:border-sky-400/60 transition-colors p-2.5 space-y-1.5"
        >
            <div className="flex items-center gap-1.5">
                <Eye className="h-3.5 w-3.5 text-sky-400 shrink-0" />
                <span className="font-mono font-bold text-sm text-slate-50">{row.symbol.replace('USDT', '')}</span>
                {m && <span className={`text-[10px] font-semibold ${m.cls}`}>{m.arrow} {rd.direction.toUpperCase()} izi</span>}
                {!m && <span className="text-[10px] text-slate-500">yön net değil</span>}
                <span className="ml-auto font-mono text-[10px] text-slate-300" data-testid={`radar-watch-count-${row.symbol}`}>{rd.passed_count}/7</span>
            </div>
            <div className="text-[10px] text-slate-400 truncate" title={passedKeys.join(', ')}>
                Geçen: {passedKeys.length ? passedKeys.join(', ') : '—'}
            </div>
            {rd.near_hard?.length ? (
                <div className="space-y-1">
                    <div className="text-[9px] uppercase tracking-wider text-amber-200/90">Eksik kanıt — eşiğe yakınlık</div>
                    {rd.near_hard.slice(0, 2).map((n) => <NearChip key={n.key} n={n} symbol={row.symbol} />)}
                </div>
            ) : (
                <div className="text-[10px] text-slate-500">Sert kanıt henüz uzak — birikim/OI/hacim/kırılım bekleniyor</div>
            )}
            {rd.order_plan?.mode === 'conditional' && (
                <div data-testid={`radar-watch-plan-${row.symbol}`} className="text-[10px] text-slate-300 font-mono truncate" title={rd.order_plan.confirm_tr}>
                    Plan: tetik {fmt(rd.order_plan.trigger_price)} · stop {fmt(rd.order_plan.stop)} · TP1 {fmt(rd.order_plan.tp1)}
                </div>
            )}
        </button>
    );
}
